<template>
  <div
    id="mk-configurator"
    class="mk-configurator"
    :class="stepActive == 2 ? 'mk-configurator--extended':''"
  >
    <Start v-if="stepActive == -1"/>
    <Stepper v-if="stepActive >= 0"/>
    <div class="mk-content" :class="stepActive == 2 ? 'mk-content--extended':''">
      <TableSelection v-if="stepActive == 0"/>
      <div
        v-if="stepActive > 0"
        class="mk-content__split"
        :class="stepActive == 2 ? 'mk-content__split--flow':''"
      >
        <DimensionSelection v-if="stepActive == 1"/>
        <GlassSelection v-if="stepActive == 2"/>
        <Checkout v-if="stepActive == 3"/>
        <Visualization class="mk-content__visualization"/>
        <ContinueButton v-if="stepActive != 3"/>
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>

<script>
/**
 * APP
 * @author David <david.prenninger@gmx.de>
 *
 * Base component of Configurator. It contains the configuration header and the content section.
 * This section basically acts like a simple rooter, always showing the selected section.
 */
import ContinueButton from '@/components/ContinueButton.vue';

import TableSelection from '@/views/TableSelection.vue';
import DimensionSelection from '@/views/DimensionSelection.vue';
import GlassSelection from '@/views/GlassSelection.vue';
import Checkout from '@/views/Checkout.vue';
import Start from '@/views/Start.vue';

import Stepper from './components/Stepper.vue';
import Loader from './components/Loader.vue';
import Visualization from './components/Visualization.vue';

export default {
  name: 'App',
  components: {
    TableSelection,
    GlassSelection,
    DimensionSelection,
    Checkout,
    Stepper,
    Visualization,
    ContinueButton,
    Start,
    Loader,
  },
  computed: {
    // Currently active configuration Step
    stepActive() {
      return this.$store.getters.stepActive;
    },
    // Global loading variable
    loading() {
      return this.$store.getters.loading;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/defaults.scss";
@import "@/assets/style/tooltip.scss";

.mk-configurator {
  font-family: 'Roboto', sans-serif;
  text-align: center;
  color: $c_primary;
  // border: 1px solid $c_primary;
  box-shadow: $bs_md;
  margin: 0 auto;
  min-width: 350px;
  width: 80%;
  max-width: 1000px;
  min-height: 600px;
  height: 800px;
  // width: 70%;
  position: relative;
  background-color: $c_white;
  font-size: 16px;
  line-height: normal;
  box-sizing: content-box;

  @media (max-width: 700px) {
    width: 100% ;
  }

  @media (max-width: 900px) {
    height: 1200px;
  }

  .mk-content {
    position: absolute;
    z-index: 3;
    height: calc(100% - 45px);
    margin-top: 45px;
    width: 100%;

    &--extended {
      @media (max-width: 700px) {
        height: 955px;
      }
    }

    &__split {
      display: flex;
      height: 100%;
      overflow: hidden;
      width: 100%;

      @media (max-width: 900px) {
        flex-direction: column-reverse;
      }

      &--flow {
        flex-direction: column-reverse;
        width: 100%;
      }
    }
  }
}
</style>
